/** Resolve the only product API authority: the configured Gateway base URL. */
export function getGatewayBaseUrl(): string {
  const gatewayBase = import.meta.env.VITE_API_BASE_URL?.trim().replace(/\/+$/, "") ?? "";
  if (!gatewayBase) {
    throw new Error("VITE_API_BASE_URL is required; direct service fallback is forbidden");
  }
  return gatewayBase;
}
